/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileAwardsWithProfiles } from '../../models/profile-awards-with-profiles';

export interface ListAwards$Params {
  max: number;
}

export function listAwards(http: HttpClient, rootUrl: string, params: ListAwards$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProfileAwardsWithProfiles>>> {
  const rb = new RequestBuilder(rootUrl, listAwards.PATH, 'get');
  if (params) {
    rb.path('max', params.max, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ProfileAwardsWithProfiles>>;
    })
  );
}

listAwards.PATH = '/rest/awards/{max}';
